var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyesD(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 24,
    viewBox: "0 0 107 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 24C3.92487 24 -5.71532e-07 23.0751 -3.0598e-07 17C-4.04272e-08 10.9249 3.92487 10 10 10C16.0751 10 20 10.9249 20 17C20 23.0751 16.0751 24 10 24Z",
    fill: "#DE9079",
    fillOpacity: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M97 24C90.9249 24 87 23.0751 87 17C87 10.9249 90.9249 10 97 10C103.075 10 107 10.9249 107 17C107 23.0751 103.075 24 97 24Z",
    fill: "#DE9079",
    fillOpacity: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4 9C8.05376 2.92561 23.6868 2.92553 37 9C37 -0.387734 4 -5.3577 4 9Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M103 9C98.9462 2.92561 83.3132 2.92553 70 9C70 -0.387734 103 -5.3577 103 9Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyesD);
export default __webpack_public_path__ + "static/media/Eyes D.0ebdfdda3e33447979eb4d8abf29ff34.svg";
export { ForwardRef as ReactComponent };